import React, {useCallback, useMemo, useRef, useState, useEffect} from 'react';
import {Helmet} from 'react-helmet';
import {Header, Titulo, ContenedorHeader} from './../elementos/Header';
import { GoogleMap, Marker, useJsApiLoader, useLoadScript } from '@react-google-maps/api';
import {  Contenedor, Controles, ContenedorMapa,BotonsRecarga,Icono } from '../elementos/ElementosMapa';
import useObtenerActivos from './../hooks/useObtenerActivos';
import BtnRegresar from "../elementos/BtnRegresar";
import BtnMapa from "../elementos/BtnMapa";
import iconActivo from './../imagenes/rojo.png';
import iconDisponible from './../imagenes/verde.png';
import useObtenerViajesActivos from './../hooks/useObtenerViajesActivos';
import {auth} from '../firebase/firebaseConfig';
import { useAuth } from './../contextos/AuthContext';
import useObtenerAdmin from './../hooks/useObtenerAdmin';





const Mapa = () => {
var conductores = useObtenerActivos();
var viajesActivos = useObtenerViajesActivos();
const [TipoUsuario, cambiarTipoUsuario] = useState([]);
const {usuario} = useAuth();
const uid = usuario.uid
const UsarioLog = useObtenerAdmin({uid});
const [Escliente, cambiarEscliente] = useState(true);
const [moviles, cambiarMoviles] = useState([]);
const [fechaActualp, cambiarFechaActualP] = useState (new Date());



const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_APIKEY,
    libraries: ["places"]
    })
const centro = useMemo(() => ({lat: -33.43741517966219,lng: -70.65049628138881}),[]);
const activos = useMemo(() => conductores,[conductores])
const options = useMemo(() => ({
    mapId:"2a56e698e3a7992c",
    disableDefaultUI:true,
    clickableIcons: false,
}),[]);


useEffect (()=>{    
  
  if (UsarioLog.cliente === 'undefined' || UsarioLog.cliente === 'Sin Permisos' || UsarioLog.cliente === null)
  {cambiarTipoUsuario('salir')}
  else
  {    
    if (UsarioLog.cliente === 'R.T ESTRELLA' || UsarioLog.cliente === 'R.T Estrella')
      {cambiarTipoUsuario('admin')}
    else
      {
        if (Number(UsarioLog.numero) > 0)
        {{cambiarTipoUsuario('conductor')}
      }
        else{
          {cambiarTipoUsuario('cliente')}
      }
        
      }
  }
},[UsarioLog]);
/*
useEffect(() => {
  const timer = setTimeout(() => {
    cambiarFechaActualP(new Date()); 
  }, 60000);
  console.log("actualiza fecha")
  conductores = ('');
  return () => clearTimeout(timer);
  
}, [fechaActualp]);
*/

useEffect(() => {
cambiarMoviles(conductores)
  }, [conductores]);

const onclick = () => {
    cambiarMoviles(conductores)
}

const mapContainerStyle = {width: "100%",height: "100%"}
const position = { lat: -33.43741517966219, lng: -70.65049628138881 };
const position2 = { lat: -33.412547292256114, lng: -70.79317996133058 };

const findElement = (array, searchedAge) => {
  return array.find(element => element.numero_m === searchedAge) ?? -1;
}


//console.log(viajesActivos)
//console.log(findElement(viajesActivos, "99").estado)
if (viajesActivos.hasOwnProperty("numero_m")){
}


const [show, setShow] = React.useState(false)
  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setShow(true)
    }, 2000)
    return () => clearTimeout(timeout)
  }, [show])

  if (!show) return null
  return (
		<>
			<Helmet>
				<title>Mapa</title>
			</Helmet>

			<Header>
				<ContenedorHeader>
                <BtnRegresar></BtnRegresar>
					<Titulo>Mapa de Ubicación de Móviles</Titulo>
				</ContenedorHeader>
			</Header>
           <Contenedor>
                <Controles>
                    <h1></h1>
                </Controles>
                <ContenedorMapa>
                <GoogleMap 
                zoom={11} 
                center={centro} 
                mapContainerStyle={mapContainerStyle}
                options={options}
                >{activos.map((conductor,index) => {
                  console.log("conductor")
                  console.log(conductor)
                  console.log("viajesActivos")
                  console.log(viajesActivos)
                  console.log("Usuario")
                  console.log(UsarioLog)
                  console.log("Tipo Usuario")
                  console.log(TipoUsuario)

                  if (TipoUsuario === 'admin') {
                  if(findElement(viajesActivos, conductor.numero_m).estado==="Activo"){
                    return( 
                      <Marker key={index} position={{ lat: conductor.lat, lng: conductor.lng }} label={conductor.numero_m} icon={iconActivo}/> 
                      )
                  }
                  else{
                    return( 
                      <Marker key={index} position={{ lat: conductor.lat, lng: conductor.lng }} label={conductor.numero_m} icon={iconDisponible}/> 
                      
                      )
                  }
                }else {
                  if (UsarioLog.cliente==='Grupo Mutual')  
                    {

                      if((findElement(viajesActivos, conductor.numero_m).estado==="Activo")&& (
                      (findElement(viajesActivos, conductor.numero_m).empresa==='Mutual Agustinas ') ||
                      (findElement(viajesActivos, conductor.numero_m).empresa==='Mutual De Seguridad') ||
                      (findElement(viajesActivos, conductor.numero_m).empresa==='Mutual Enea') ||
                      (findElement(viajesActivos, conductor.numero_m).empresa==='Mutual La Florida') ||
                      (findElement(viajesActivos, conductor.numero_m).empresa==='Mutual Lo Espejo') ||
                      (findElement(viajesActivos, conductor.numero_m).empresa==='Mutual Maipu') ||
                      (findElement(viajesActivos, conductor.numero_m).empresa==='Mutual Paine') ||
                      (findElement(viajesActivos, conductor.numero_m).empresa==='Mutual Providencia') ||
                      (findElement(viajesActivos, conductor.numero_m).empresa==='Mutual Puente Alto') ||
                      (findElement(viajesActivos, conductor.numero_m).empresa==='Mutual Quilicura') ||
                      (findElement(viajesActivos, conductor.numero_m).empresa==='MUTUAL SAM615') ||
                      (findElement(viajesActivos, conductor.numero_m).empresa==='Mutual San Bernardo') ||
                      (findElement(viajesActivos, conductor.numero_m).empresa==='Mutual Talagante')

                      )
                      )
                      {
                        return( 
                          <Marker key={index} position={{ lat: conductor.lat, lng: conductor.lng }} label={conductor.numero_m} icon={iconActivo}/> 
                          )
                      }

                    }
                    else
                    {

                  if((findElement(viajesActivos, conductor.numero_m).estado==="Activo")&&(findElement(viajesActivos, conductor.numero_m).empresa===UsarioLog.cliente)){
                    return( 
                      <Marker key={index} position={{ lat: conductor.lat, lng: conductor.lng }} label={conductor.numero_m} icon={iconActivo}/> 
                      )
                  }
                 
                }}
                  }
                    )
                    
                 }
                </GoogleMap>
                    
                </ContenedorMapa>

           </Contenedor>
		</>
	);
}

export default Mapa;